import { ListGroup, ListGroupItem } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import useFetchBookingDotComPropertyScoreActions from 'components/domain/bookingDotCom/useFetchBookingDotComPropertyScoreActions';
import LoadingPlaceholder from 'components/loader/LoadingPlaceholder';
import { GetPropertyScoreActionsResponseTO as GetBookingDotComPropertyScoreActionsResponseTO } from 'models/bookingDotCom/PropertyScore';
import BookingDotComQualityScoreDoneCheck from './BookingDotComQualityScoreDoneCheck';
import usePropertyUidForQualityScore from './usePropertyUidForQualityScore';

interface BookingDotComQualityScoreTabContentProps {
  category: keyof GetBookingDotComPropertyScoreActionsResponseTO;
}

const BookingDotComQualityScoreTabContent = ({
  category,
}: BookingDotComQualityScoreTabContentProps) => {
  const { t } = useTranslation();
  const propertyUid = usePropertyUidForQualityScore();
  const { data: propertyScoreActions, isLoading } =
    useFetchBookingDotComPropertyScoreActions({ propertyUid });

  const metrics = propertyScoreActions?.[category]?.metrics;
  const hasMetrics = !!metrics?.length;
  const title = hasMetrics
    ? t('pageProperty.reviews.bookingDotCom.metricsTitle', {
        context: category,
      })
    : t('pageProperty.reviews.bookingDotCom.emptyMetricsTitle', {
        context: category,
      });

  if (isLoading) {
    return (
      <div>
        <LoadingPlaceholder />
      </div>
    );
  }

  return (
    <div data-testid="metrics">
      <span data-testid="metrics-title">{title}</span>
      {hasMetrics && (
        <ListGroup>
          {metrics.map((metric) => (
            <ListGroupItem
              className={`${metric.done ? 'done' : ''}`}
              key={metric.metricId}
            >
              <span>
                {t('pageProperty.reviews.bookingDotCom.metrics', {
                  context: metric.metricId,
                  defaultValue: metric.action,
                })}
              </span>

              <BookingDotComQualityScoreDoneCheck done={metric.done} />
            </ListGroupItem>
          ))}
        </ListGroup>
      )}
    </div>
  );
};

export default BookingDotComQualityScoreTabContent;
